<template>
    <div>
        <div class="sub-nav">
            <div class="wrap">
                <ul>
                    <li>
                        <router-link :to="{ path: '/presentations' }">
                            <span
                                :style="{ borderBottom: outStyle }"
                                >EVENTS & PRESENTATIONS</span
                            >
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/pressReleases' }">
                            <span class="active">PRESS RELEASES</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/secFilings' }">
                            <span class="active">REPORTS & FILINGS</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/stockPerformance' }">
                            <span class="active">STOCK PERFORMANCE</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{ path: '/corporateGovernance' }">
                            <span class="active" :style="{ borderBottom: leadStyle }">CORPORATE GOVERNANCE</span>
                        </router-link>
                    </li>
                    <!-- <li>
                        <router-link :to="{ path: '/relationsContact' }">
                        <span class="active">INVESTOR RELATIONS CONTACT</span>
                        </router-link>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["outStyle","leadStyle"],
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
&.router-link-active {
    //表示router-link激活选中时的状态
    .active {
        border-bottom: 2px solid #283254;
    }
}
html{
    font-family: Lucida Bright;
}
//列表导航
.sub-nav {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #f2f2f2;
    ul {
        display: flex;
        li {
            font-size: 13px;
            color: #333333;
            width: 20%;
            span {
                display: inline-block;
                height: 48px;
                line-height: 48px;
                margin-right: 35px;
                cursor: pointer;
            }
            // .active {
            //     border-bottom: 2px solid #283254;
            // }
        }
    }
}
</style>